export default {
  "path": "/demo/table-drag",
  "meta": {
    "name": "demo-列表拖拽",
    "title": "列表拖拽",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};